module.exports = __webpack_public_path__ + "static/media/transportation.aadf1c4d.png";